import { AttributeIdentifiers } from "@lyfegen-platform/graphql-schema/models";
import { useSetFieldValue } from "formik";
import { FlexContext } from "../models/flexible/flex-context";
import { createSingleSectionInstanceInitialValues } from "../models/flexible/initial-values";

export const useClearEnrollingConditionSet = (context: FlexContext) => {
	const setFieldValue = useSetFieldValue();

	return () => {
		if (
			context.sectionControllers.some((sectionController) =>
				sectionController.fieldControllers.some(
					(fieldController) => fieldController.schema.attribute.identifier === AttributeIdentifiers.Disease
				)
			)
		) {
			setFieldValue(AttributeIdentifiers.Disease, "");
		}

		if (
			context.sectionControllers.some((sectionController) =>
				sectionController.fieldControllers.some(
					(fieldController) => fieldController.schema.attribute.identifier === AttributeIdentifiers.Indication
				)
			)
		) {
			setFieldValue(AttributeIdentifiers.Indication, "");
		}

		const preparationsSection = context.sectionControllers.find((sectionController) =>
			sectionController.fieldControllers.some(
				(fieldController) => fieldController.schema.attribute.identifier === AttributeIdentifiers.BrandName
			)
		);
		if (!preparationsSection) {
			return;
		}

		if (preparationsSection.schema.isArray) {
			setFieldValue(preparationsSection.schema.localizableKey, [
				createSingleSectionInstanceInitialValues(preparationsSection, {}, {}),
			]);
			return;
		}

		setFieldValue(AttributeIdentifiers.BrandName, []);
		setFieldValue(AttributeIdentifiers.GenericName, "");
	};
};
